import type React from 'react';
import { useEffect } from 'react';
import { useDefinitionModal } from '../../contexts/DefinitionModalContext';
import {
  initializeNewwindow,
  setDefinitionModalOpener,
} from '../../util/newwindow';
import DefinitionModal from './DefinitionModal';

const DefinitionModalContainer: React.FC = () => {
  const { isOpen, juriID, renID, refID, pageID, closeModal, openModal } =
    useDefinitionModal();

  useEffect(() => {
    // Set the global function that can be called from CKEditor
    setDefinitionModalOpener(openModal);

    // Initialize the global newwindow function
    initializeNewwindow();
  }, [openModal]);

  return (
    <DefinitionModal
      isOpen={isOpen}
      onClose={closeModal}
      juriID={juriID}
      renID={renID}
      refID={refID}
      pageID={pageID}
    />
  );
};

export default DefinitionModalContainer;
